import { Button } from '@/components/atoms';
import { pcompany } from '@/proto/proto';
import DefaulthModal from '@/components/organisms/common/modal/DefaultModal';
import { useState } from 'react';
import { ModalStaticFunctions } from 'antd/lib/modal/confirm';
import api from '@/api';
import { message, Input } from 'antd';

const { Search } = Input;

export type ManageCompanySearchModalProps = {
  visible: boolean;
  onClose: () => void;
  modal?: Pick<ModalStaticFunctions, 'info' | 'confirm'>;
};

const ManageCompanySearchModal = ({ visible, onClose, modal }: ManageCompanySearchModalProps) => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchList, setSearchList] = useState<any[]>([]);

  const search = () => {
    api.get('/company/all', { params: { keyword: searchKeyword } }).then(({ data }) => {
      setSearchList(data.company);
    });
  };

  const requestJoin = (companyId: string) => {
    api
      .post('/company/user/join', 'pcompany.PbCompanyJoinRequest', { companyId })
      .then(() => {
        onClose();
      })
      .catch((e) => {
        message.error('가입 신청에 실패했습니다.');
      });
  };

  return (
    <DefaulthModal
      modalVisible={visible}
      titleText="회사 조회"
      onCancel={() => {
        setSearchKeyword('');
        setSearchList([]);
        onClose();
      }}
    >
      <div className="flex flex-col">
        <Search placeholder="회사명" style={{ width: 300 }} onChange={(e) => setSearchKeyword(e.target.value)} onSearch={search} />
        {searchList.length === 0 && (
          <div className="flex flex-col justify-center items-center overflow-y-auto" style={{ minHeight: '200px', maxHeight: '400px' }}>
            데이터가 없습니다.
          </div>
        )}
        {searchList.length > 0 && (
          <div className="mt-4 flex flex-col overflow-y-auto" style={{ minHeight: '200px', maxHeight: '400px' }}>
            {searchList.map((searchCompany: pcompany.IPbCompany) => (
              <div key={`${searchCompany.base?.id}`} className="p-3 border rounded flex justify-between items-center">
                <div className="flex flex-col">
                  {searchCompany.name}
                  <small>{searchCompany.addr1}</small>
                </div>
                <Button
                  type="dark"
                  shape="round"
                  onClick={() =>
                    modal?.confirm({
                      className: 'pincarbiz',
                      title: '가입 요청',
                      content: <div>&apos;{searchCompany.name}&apos; 회사에 가입 신청하시겠습니까?</div>,
                      centered: true,
                      onOk: () => {
                        requestJoin(`${searchCompany.base?.id}`);
                      },
                    })
                  }
                >
                  가입 요청
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </DefaulthModal>
  );
};

export default ManageCompanySearchModal;
